import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

const options = [
  { label: 'Paulinia', value: 'PLN' },
  { label: 'Franco da Rocha', value: 'FDR' },
  { label: 'Sem planta de destino', value: 'NULL' },
];

export const useDestinationPlantOptions = () => {
  return {
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  }
};